import React from "react";
import { Images } from "./Images";
import "../CSS/Tools.css";

const List=[
    {
        Asset: Images.Photoshop,
        Titles:"Photoshop"
    },
    {
        Asset: Images.Illustrator,
        Titles:"Illsutrator"
    },
    {
        Asset: Images.Coreldraw,
        Titles:"Coreldraw"
    },
    {
        Asset: Images.Sketch,
        Titles:"Sketch"
    },
    {
        Asset: Images.Figma,
        Titles:"Figma"
    },
    {
        Asset: Images.XD,
        Titles:"Adobe Xd"
    },
    {
        Asset: Images.Aftereffect,
        Titles:"After Effect"
    },
    {
        Asset: Images.Premier,
        Titles:"Premier Pro"
    },
    {
        Asset: Images.Protoio,
        Titles:"Proto.Io"
    },
    {
        Asset: Images.Framer,
        Titles:"Framer"
    },
    {
        Asset: Images.Zepline,
        Titles:"Zepline"
    },
    {
        Asset: Images.Anima,
        Titles:"Anima"
    },  
]


export const Tools=()=>{
    return(
        <div className="toolscontainer">
             <h1 className="Skillhead">Tools</h1>
                <div className="align">
                {List.map((tool)=>{
                    return(
                        <Glass greenglass={tool.Asset} text={tool.Titles}/>
                    )
                })
            }
        </div>
        </div>
        
    )
}

const Glass=({greenglass, text})=>{
    return(
        <div className="Inner">
            <img className="glassgreen" src={greenglass} alt='GG' />
            <p className="Textss">{text}</p> 
        </div>
    )
}